<script setup lang="ts">
import { DropdownMenuContent, useForwardPropsEmits } from 'radix-vue'
import type {
  DropdownMenuContentEmits,
  DropdownMenuContentProps,
} from 'radix-vue'

const props = withDefaults(defineProps<DropdownMenuContentProps>(), {
  sideOffset: 4,
})
const emits = defineEmits<DropdownMenuContentEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <DropdownMenuContent :class="$style.content" v-bind="forwarded">
    <slot />
  </DropdownMenuContent>
</template>

<style lang="scss" module>
.content {
  background-color: $color-surface-primary;
  border: 1px solid $color-border-low-emphasis;
  box-shadow: $shadow-4;
  border-radius: $border-radius-inner;

  > *:not(:first-child) {
    border-top: 1px solid $color-border-low-emphasis;
  }
}
</style>
